<template>
  <div>
    <div class="ant-descriptions-title">
      Thông tin nghỉ ốm
    </div>
    <a-descriptions :column="2">
      <a-descriptions-item label="Tổng số ngày nghỉ ốm"> </a-descriptions-item>
      <a-descriptions-item label="Số ngày nghỉ ốm còn lại">
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="css" scoped></style>
